import type { IAuthSettingsRestrictionsData } from '../../../common/interfaces/authSetting';

export const defaultAuthSettingsRestrictionsData: IAuthSettingsRestrictionsData = {
    restrictBasicAuthentication: false,
    enableBasicAuthenticationForHostTenant: true,
};
